// mz-condition-collection-fallback-v2 20260722T1136Z
(function() {
  function ensureStyles() {
    if (document.getElementById('mz-condition-filter-critical-css')) return;
    var style = document.createElement('style');
    style.id = 'mz-condition-filter-critical-css';
    style.textContent = [
      '.mz-condition-filter{--mz-condition-orange:#d74d01;--mz-condition-green:#178a42;box-sizing:border-box!important;display:block!important;margin:0 0 10px!important;max-width:100%!important;overflow:visible!important;padding:0 0 10px!important;width:100%!important}',
      '.mz-condition-filter *,.mz-condition-filter *:before,.mz-condition-filter *:after{box-sizing:border-box!important}',
      '.mz-condition-filter__title{color:#1f1f1f!important;font:inherit!important;font-size:13px!important;font-weight:800!important;letter-spacing:0!important;line-height:1.2!important;margin:0 0 8px!important;text-transform:none!important}',
      '.mz-condition-filter__buttons{display:grid!important;gap:8px!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;max-width:100%!important;width:100%!important}',
      '.mz-condition-filter__button{align-items:center!important;background:#fff!important;border:2px solid var(--mz-condition-orange)!important;border-radius:8px!important;box-shadow:none!important;color:#1f1f1f!important;display:inline-flex!important;font-family:inherit!important;font-size:14px!important;font-weight:700!important;gap:8px!important;justify-content:center!important;line-height:1.2!important;min-height:40px!important;min-width:0!important;padding:8px 10px!important;text-align:center!important;text-decoration:none!important;white-space:normal!important;width:100%!important}',
      '.mz-condition-filter__button:hover,.mz-condition-filter__button:focus{background:#fff7f1!important;color:#1f1f1f!important;outline:none!important;text-decoration:none!important}',
      '.mz-condition-filter__button.is-active{background:#fff7f1!important;box-shadow:inset 0 0 0 1px var(--mz-condition-orange)!important}',
      '.mz-condition-filter__icon{color:var(--mz-condition-orange)!important;display:inline-block!important;flex:0 0 auto!important;font-size:18px!important;font-weight:800!important;line-height:1!important;width:1.1em!important}',
      '.mz-condition-filter__button--used .mz-condition-filter__icon{color:var(--mz-condition-green)!important}',
      '.mz-condition-filter+.mz-condition-filter{display:none!important}',
      '@media (max-width:600px){.mz-condition-filter{margin-bottom:6px!important;padding-bottom:6px!important}.mz-condition-filter__button{font-size:13px!important;gap:6px!important;padding-left:8px!important;padding-right:8px!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function cleanTitle(raw, fallbackHandle) {
    var title = String(raw || '').replace(/\s+Ersatzteile\s*$/i, '').replace(/\s+/g, ' ').trim();
    if (title) return title;
    return decodeURIComponent(fallbackHandle || '')
      .replace(/-/g, ' ')
      .replace(/\bersatzteile\b/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function run() {
    ensureStyles();
    var collectionMatch = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!collectionMatch) return;
    var conditionFilters = Array.prototype.slice.call(document.querySelectorAll('.mz-condition-filter'));
    if (!conditionFilters.length) return;

    var keep = document.querySelector('#filters .mz-condition-filter') || conditionFilters[0];
    conditionFilters.forEach(function(filter) {
      if (filter !== keep && filter.parentNode) {
        filter.parentNode.removeChild(filter);
      }
    });

    var filtersHost = document.getElementById('filters');
    if (filtersHost) {
      Array.prototype.slice.call(filtersHost.children).forEach(function(child) {
        if (!child.classList || !child.classList.contains('mz-condition-filter')) {
          child.parentNode.removeChild(child);
        }
      });
    }

    var heading = document.querySelector('#collection h1, #collection h2, .section-title, h1');
    var title = cleanTitle(heading && heading.textContent, collectionMatch[1]);
    if (!title) return;
    var localeMatch = window.location.pathname.match(/^\/(ar|bg|cs|da|el|en|es|et|fi|fr|he|hr|hu|it|ja|lt|lv|nl|no|pl|pt|ru|sv|zh)(?:-[a-z]{2})?\//i);
    var searchPath = (localeMatch ? '/' + localeMatch[1] : '') + '/search';

    Array.prototype.slice.call(document.querySelectorAll('.mz-condition-filter__button')).forEach(function(button) {
      if (button.classList.contains('mz-condition-filter__button--used')) {
        button.href = searchPath + '?q=' + encodeURIComponent(title + ' tag:Gebrauchtteil').replace(/%20/g, '+') + '&type=product';
      } else if (button.classList.contains('mz-condition-filter__button--new')) {
        button.href = searchPath + '?q=' + encodeURIComponent(title + ' tag:Neuteil').replace(/%20/g, '+') + '&type=product';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  window.setTimeout(run, 250);
}());
